/**
 * Workflows Hub.
 *
 * Business process tools: step-by-step processes, custom form templates,
 * and automation rules — all in a focused tabbed interface.
 */

import { Link } from "react-router-dom";
import { FileText, Zap, ArrowLeft, Workflow } from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import ProcessesPage from "@/pages/ProcessesPage";
import FormTemplatesPage from "@/pages/FormTemplatesPage";
import AutomationsPage from "@/pages/AutomationsPage";

const tabs = [
  { key: "processes", label: "Processes", icon: Workflow },
  { key: "forms", label: "Forms", icon: FileText },
  { key: "automations", label: "Automations", icon: Zap },
];

function AdminWorkflowsHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "processes");

  return (
    <div className="page-content space-y-6">
      <div className="flex items-start gap-4">
        <Link
          to="/admin"
          className="mt-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-secondary)] transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h2 className="text-2xl font-bold text-[var(--text-primary)]">
            Workflows
          </h2>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">
            Build processes, create custom forms, and configure automation
            rules.
          </p>
        </div>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "processes" && <ProcessesPage />}
      {activeTab === "forms" && <FormTemplatesPage />}
      {activeTab === "automations" && <AutomationsPage />}
    </div>
  );
}

export default AdminWorkflowsHub;
